import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';

@Injectable()
export class RoleGuard implements CanActivate {
    constructor(public router: Router,
        private authService: AuthService) { }
    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (this.authService.isLogged()) {
            let permittedRoles = route.data.roles;
            let userRoles = this.authService.getUserRoles();
            if(!this.authService.getUser()) {
                // this.authService.getUserRolesAfterLogin().subscribe(res => {
                //     this.router.navigate(["pages", "dashboard"]);
                // })
            } else {

                if (_.some(userRoles, (role) => _.includes(permittedRoles, role))) {
                    return true
                } else if (_.some(userRoles, (role) => _.includes(role, 'ROL_ADMINISTRACION_'))) {
                    this.router.navigate(["pages", "administration"]);
                }
                else {
                    this.router.navigate(["pages", "dashboard"]);
                    return false;
                }
            }
        }
    }
}